import { createI18n } from 'vue-i18n';
import { getCurrentLanguage } from '@eureka/language-tool';

export const i18n = createI18n({
    legacy: false,
    locale: getCurrentLanguage(),
    fallbackLocale: 'en',
    messages: {},
});
